import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SessionStorageService } from '@shared/services/storage.service';
import { IAccount } from '@shared/services/user.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MesBatchService {
	constructor(
		private http: HttpClient,
		private sessionStorageService: SessionStorageService,
	) {}

	getUrl(id?: string | null) {
		return `${environment.awsEnvUri}/mes/batches${id ? `/${id}` : ''}`;
	}

	getAll(): Observable<IBatches> {
		return this.http.get<IBatches>(this.getUrl(), {
			headers: this.getHeaders(),
		});
	}

	getById(id: string): Observable<IBatchResponse> {
		return this.http.get<IBatchResponse>(this.getUrl(id), {
			headers: this.getHeaders(),
		});
	}

	create(item: IPostBatchRequest): Observable<IBatch> {
		return this.http.post<IBatch>(
			this.getUrl(),
			{
				alias: item.alias,
				name: item.name,
				status: item.status,
			} as IPostBatchRequest,
			{
				headers: this.getHeaders(),
			},
		);
	}

	update(item: IPutBatchRequest): Observable<IBatch> {
		return this.http.put<IBatch>(
			this.getUrl(item.id),
			{
				alias: item.alias,
				name: item.name,
				status: item.status,
				errors: item.errors,
			} as IPutBatchRequest,
			{
				headers: this.getHeaders(),
			},
		);
	}

	deleteById(id: string): Observable<any> {
		return this.http.delete(this.getUrl(id), {
			headers: this.getHeaders(),
		});
	}

	getHeaders() {
		return {
			Authorization: `Bearer ${this.sessionStorageService.get('User.Authorization')}`,
			'x-account-id': (JSON.parse(this.sessionStorageService.get('User.Account')) as IAccount).id,
		};
	}
}

export interface IBatches {
	result: IBatch[];
}
export interface IBatchResponse {
	result: IBatch;
}
export interface IPutBatchRequest extends IInternalBatch {
	id: string;
}
export interface IPostBatchRequest extends IInternalBatch {}
export interface IBatch extends IInternalBatch {
	id: string | null;
}

interface IInternalBatch {
	alias: string;
	name?: string;
	sourceId?: string;
	status: IBatchStatus;
	errors: IBatchError[];
}

export interface IBatchError {
	terminalId: string;
	type: string;
	message: string;
}

export enum IBatchStatus {
	Draft = 'Draft',
	Failed = 'Failed',
	Prepare = 'Prepare',
	Ready = 'Ready',
	Production = 'Production',
	Done = 'Done',
	Archived = 'Archived',
}

const indexToBatchStatus: Record<number, IBatchStatus> = {
	0: IBatchStatus.Draft,
	1: IBatchStatus.Failed,
	2: IBatchStatus.Prepare,
	3: IBatchStatus.Ready,
	4: IBatchStatus.Production,
	5: IBatchStatus.Done,
	6: IBatchStatus.Archived,
};

export function integerToBatchStatus(code: string | number): IBatchStatus | undefined {
	return indexToBatchStatus[Number(code)];
}

export const isInteger = (s: string): boolean => Number.isInteger(+s) && s.trim() !== '';
